"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable jsx-a11y/label-has-for */

/* eslint-disable jsx-a11y/label-has-associated-control */


var Radio = function Radio(props) {
  var name = props.name,
      className = props.className,
      _onChange = props.onChange,
      value = props.value,
      checked = props.checked,
      required = props.required,
      label = props.label;
  return _react.default.createElement("label", {
    className: "".concat(_styleModule.default.radioButton, " ").concat(className)
  }, _react.default.createElement("input", {
    name: name,
    type: "radio",
    defaultChecked: checked,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    },
    required: required,
    value: value
  }), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("span", null)), _react.default.createElement("span", null, label)));
};

Radio.defaultProps = {
  className: '',
  onChange: function onChange(value) {
    return value;
  },
  required: false,
  checked: false
};
Radio.propTypes = {
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  checked: _propTypes.default.bool,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  required: _propTypes.default.bool
};
var _default = Radio;
exports.default = _default;